import { createReducer, createActions } from 'reduxsauce';
import update from 'immutability-helper';
import { Planner } from 'contracts/Planners';

const { Types, Creators } = createActions(
  {
    request: ['id', 'onSuccess', 'onFailure'],
    success: ['data'],
    failure: ['errorMessage'],
    softReset: [],
    reset: [],
  },
  {
    prefix: 'FETCH_PLANNER_',
  }
);

export interface FetchPlannerState {
  data: Planner | null;
  loading: boolean;
  errorMessage: string | null;
}

export interface FetchPlannerRequestAction {
  id: number;
  onSuccess?: () => void;
  onFailure?: () => void;
}

interface SuccessAction {
  data: Planner;
}

interface FailureAction {
  errorMessage: string;
}

const INITIAL_STATE: FetchPlannerState = {
  data: null,
  loading: false,
  errorMessage: null,
};

const request = (state: FetchPlannerState) =>
  update(state, {
    loading: { $set: true },
    errorMessage: { $set: null },
  });

const success = (state: FetchPlannerState, action: SuccessAction) =>
  update(state, {
    loading: { $set: false },
    data: { $set: action.data },
  });

const failure = (state: FetchPlannerState, action: FailureAction) =>
  update(state, {
    loading: { $set: false },
    errorMessage: { $set: action.errorMessage },
  });

const softReset = (state: FetchPlannerState) =>
  update(state, {
    loading: { $set: false },
  });

const reset = () => INITIAL_STATE;

export const fetchPlanner = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.SOFT_RESET]: softReset,
  [Types.RESET]: reset,
});

export const FetchPlannerTypes = Types;
export const FetchPlannerActions = Creators;
